<template>
  <div class="instant-payment-wrapper" :class="[$i18n.locale === 'ar' ? 'ar-style' : '', packageName]">
    <!-- 标题 -->
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f9f9fb;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="handleBack" />
          <span class="tit-left">{{ $t('lang.instantPayment.title') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="main">
      <div class="title">{{ $t('lang.instantPayment.text1') }}</div>
      <div class="subtitle">{{ $t('lang.instantPayment.text2') }}</div>
      <!-- 状态 -->
      <template v-for="item in conditionsList">
        <div :key="item.condition" class="status-item">
          <div class="left">
            <template v-if="item.checkResult">
              <img v-if="packageName === 'kiko'" src="@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/success-kiko.png" alt="icon" class="icon" width="18" height="18" />
              <img v-else src="@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/success.png" alt="icon" class="icon" width="18" height="18" />
            </template>
            <template v-else>
              <img src="@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/fail.png" alt="icon" class="icon" width="18" height="18" />
            </template>
            <span class="text">{{ item.condition }}</span>
          </div>
          <div class="right">{{ item.performance }}</div>
        </div>
      </template>
      <!-- 支持的提款方式 -->
      <div class="support">{{ $t('lang.instantPayment.payTitle') }}</div>
      <template v-if="isSupport">
        <div class="no-support">{{ $t('lang.instantPayment.nonsupport') }}</div>
      </template>
      <template v-else>
        <template v-for="item in channelsList">
          <div :key="item.name" class="organization">
            <img :src="item.icon | imgPath" alt="icon" height="18" class="icon" />
            <span>{{ item.name }}</span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { apiWithdrawAutoCheckResult } from '@/api/imee'

export default {
  data() {
    const query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      isSupport: false,
      conditionsList: [],
      channelsList: []
    }
  },
  mounted() {
    this.handleGetStatus()
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    async handleGetStatus() {
      try {
        const res = await apiWithdrawAutoCheckResult()
        this.conditionsList = (res || {}).conditions || []
        this.channelsList = (res || {}).instantPayChannels || []
        if (this.channelsList.length === 0) {
          this.isSupport = true
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.instant-payment-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;

  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: 20px;
    .title {
      width: 100%;
      height: fit-content;
      padding-bottom: 32px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      font-style: normal;
    }
    .subtitle {
      width: 100%;
      height: fit-content;
      padding-bottom: 16px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
      font-style: normal;
    }
    .status-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: fit-content;
      padding-bottom: 24px;
      .left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: fit-content;
        height: 20px;
        .icon {
          margin-right: 4px;
        }
        .text {
          font-family: RobotoFlex, RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 20px;
          font-style: normal;
        }
      }
      .right {
        width: fit-content;
        height: 20px;
        font-family: RobotoFlex, RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 20px;
        text-align: center;
        font-style: normal;
      }
    }
    .support {
      width: 100%;
      height: 20px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 16px;
    }
    .no-support {
      width: 100%;
      height: 18px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #999999;
      line-height: 18px;
    }
    .organization {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 20px;
      margin-bottom: 24px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      font-style: normal;
      .icon {
        margin-right: 4px;
      }
    }
  }
}

.instant-payment-wrapper.kiko {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;

  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: 20px;
    .title {
      width: 100%;
      height: fit-content;
      padding-bottom: 32px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      font-style: normal;
    }
    .subtitle {
      width: 100%;
      height: fit-content;
      padding-bottom: 16px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
      font-style: normal;
    }
    .status-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: fit-content;
      padding-bottom: 24px;
      .left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: fit-content;
        height: 20px;
        .icon {
          margin-right: 4px;
        }
        .text {
          font-family: RobotoFlex, RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 20px;
          font-style: normal;
        }
      }
      .right {
        width: fit-content;
        height: 20px;
        font-family: RobotoFlex, RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 20px;
        text-align: center;
        font-style: normal;
      }
    }
    .support {
      width: 100%;
      height: 20px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: bold;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 16px;
    }
    .no-support {
      width: 100%;
      height: 18px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #999999;
      line-height: 18px;
    }
    .organization {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 20px;
      margin-bottom: 24px;
      font-family: RobotoFlex, RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      font-style: normal;
      .icon {
        margin-right: 4px;
      }
    }
  }
}

.ar-style.instant-payment-wrapper {
  .main {
    .status-item {
      .left {
        .icon {
          margin-right: 0;
          margin-left: 4px;
        }
      }
    }
    .organization {
      .icon {
        margin-right: 0;
        margin-left: 4px;
      }
    }
  }
}
</style>
